"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const MemoryRepository_1 = require("../../Common/Port/MemoryRepository");
const Session_1 = require("../Session");
class SessionMemRepository extends MemoryRepository_1.MemRepository {
    constructor() {
        super();
    }
    SessionOfId(sessionId) {
        const loadedSession = super.load(sessionId);
        return loadedSession || Session_1.Session.INVALID_SESSION;
    }
    async SessionOfIdAsync(sessionId) {
        const loadedSession = await super.loadAsync(sessionId);
        return loadedSession || Session_1.Session.INVALID_SESSION;
    }
    Save(item) {
        if (!super.contains(item.id)) {
            super.save(item);
        }
        else {
            super.update(item);
        }
    }
    async ClearAsync() {
        await super.clearAsync();
    }
}
exports.SessionMemRepository = SessionMemRepository;
//# sourceMappingURL=SessionMemRepository.js.map